const InitialQuotationState = {
    // gerberImageData: null,
    gerberFileKey : "",
    naviUserName : "",
    fileName : "",
    conformBtn : false,
    qsdcls :'',
    heightSet:'',
    currentTopic:null,
    lang : "ja",
    editCartItemId : null,
    quotationSumHeight:'',
    fromFlow : false,
    loggedUserId : null,
    isLogged:'',
    quotationErrorMessage:null,
    temGerberDto:null,
    temGerberDtoData:null,
    cartItemEditMode : false,
    selectedUserId : null,
    cartSummary : {
        cartTotal : 0,
        cartDiscount : 0
    },

    serviceParam : {
        layer : "",
        dimensions : "",
        sheets : "",
        thickness : "",
        color : "",
        surface : "",
        buildTime : "",
        length : 100,
        width : 100
    },

    gerberImageData: {
        fileUrl: "",
        id: -1,
        imageUrl: "",
        imageUrlBottom: "",
        imageUrlTop: "",
        key: "",
        originalFileName: ""
    },

    quotation: {
        orderType: 1,
        fileKey: "",
        pcbParam: {
            materialDetails: 0,
            panelFlag: 0,
            edgeRails : 0,
            layer: 2,
            length: 100,
            width: 100,
            qty: 5,
            thickness: 1.6,
            impedance: 1,
            pcbColor: 0,
            surfaceFinish: 0,
            copperWeight: 1,
            goldFinger: 0,
            panelByJLCPCB_X: 0,
            panelByJLCPCB_Y: 0,
            differentDesign: 1,
            flyingProbe : 1,
            castellatedHoles : 0,
            silkColor : 1,
            orderDetailsRemark: ""

        },
        smtStencilParam: {
            dimensionsID: 112,
            stencilQty: 1,
            electropolishing: 0,
            fiducials: 0,
            customizeFlag: 0,
            customizeSizeX: 0,
            customizeSizeY: 0,
            customizeSize: 0,
            stencilSide: 0,
            orderRemark: "",
            framework: 0
        }
    },

    quotation3: {
        orderType: 3,
        fileKey: "",
        pcbParam: {
            materialDetails: 0,
            panelFlag: 0,
            edgeRails : 0,
            layer: 2,
            length: 100,
            width: 100,
            qty: 5,
            thickness: 1.6,
            impedance: 1,
            pcbColor: 0,
            surfaceFinish: 0,
            copperWeight: 1,
            goldFinger: 0,
            panelByJLCPCB_X: 0,
            panelByJLCPCB_Y: 0,
            differentDesign: 1,
            flyingProbe : 1,
            castellatedHoles : 0,
            silkColor : 1,
            orderDetailsRemark: ""

        },
        smtStencilParam: {
            dimensionsID: 112,
            stencilQty: 1,
            electropolishing: 0,
            fiducials: 0,
            customizeFlag: 0,
            customizeSizeX: 0,
            customizeSizeY: 0,
            customizeSize: 0,
            stencilSide: 0,
            orderRemark: "",
            framework: 0
        }
    },

    quotationType3: {
        orderType: 3,
        fileKey: "",
        pcbParam: {
            materialDetails: 0,
            panelFlag: 0,
            edgeRails : 0,
            layer: 2,
            length: 100,
            width: 100,
            qty: 5,
            thickness: 1.6,
            impedance: 1,
            pcbColor: 0,
            surfaceFinish: 0,
            copperWeight: 1,
            goldFinger: 0,
            panelByJLCPCB_X: 0,
            panelByJLCPCB_Y: 0,
            differentDesign: 1,
            flyingProbe : 1,
            castellatedHoles : 0,
            silkColor : 1,
            orderDetailsRemark: ""
        },
        smtStencilParam: {
            dimensionsID: 112,
            stencilQty: 1,
            electropolishing: 0,
            fiducials: 0,
            customizeFlag: 0,
            customizeSizeX: 0,
            customizeSizeY: 0,
            customizeSize: 0,
            stencilSide: 0,
            orderRemark: "",
            framework: 0,

        }
    },

    serviceCardQuotation1: {
        orderType: 1,
        fileKey: "",
        pcbParam: {
            materialDetails: 0,
            panelFlag: 0,
            edgeRails : 0,
            layer: 2,
            length: 100,
            width: 100,
            qty: 5,
            thickness: 1.6,
            impedance: 1,
            pcbColor: 0,
            surfaceFinish: 0,
            copperWeight: 1,
            goldFinger: 0,
            panelByJLCPCB_X: 0,
            panelByJLCPCB_Y: 0,
            differentDesign: 1,
            flyingProbe : 1,
            castellatedHoles : 0,
            silkColor : 1,
            orderDetailsRemark: ""
        },
        smtStencilParam: {
            dimensionsID: 112,
            stencilQty: 1,
            electropolishing: 0,
            fiducials: 0,
            customizeFlag: 0,
            customizeSizeX: 0,
            customizeSizeY: 0,
            customizeSize: 0,
            stencilSide: 0,
            orderRemark: "",
            framework: 0
        }
    },
    serviceCardQuotation2: {
        orderType: 1,
        fileKey: "",
        pcbParam: {
            materialDetails: 0,
            panelFlag: 0,
            edgeRails : 0,
            layer: 2,
            length: 100,
            width: 100,
            qty: 5,
            thickness: 1.6,
            impedance: 1,
            pcbColor: 0,
            surfaceFinish: 0,
            copperWeight: 1,
            goldFinger: 0,
            panelByJLCPCB_X: 0,
            panelByJLCPCB_Y: 0,
            differentDesign: 1,
            flyingProbe : 1,
            castellatedHoles : 0,
            silkColor : 1,
            orderDetailsRemark: ""
        },
        smtStencilParam: {
            dimensionsID: 112,
            stencilQty: 1,
            electropolishing: 0,
            fiducials: 0,
            customizeFlag: 0,
            customizeSizeX: 0,
            customizeSizeY: 0,
            customizeSize: 0,
            stencilSide: 0,
            orderRemark: "",
            framework: 0
        }
    },

    serviceCardQuotation3: {
        orderType: 1,
        fileKey: "",
        pcbParam: {
            materialDetails: 0,
            panelFlag: 0,
            edgeRails : 0,
            layer: 2,
            length: 100,
            width: 100,
            qty: 5,
            thickness: 1.6,
            impedance: 1,
            pcbColor: 0,
            surfaceFinish: 0,
            copperWeight: 1,
            goldFinger: 0,
            panelByJLCPCB_X: 0,
            panelByJLCPCB_Y: 0,
            differentDesign: 1,
            flyingProbe : 1,
            castellatedHoles : 0,
            silkColor : 1,
            orderDetailsRemark: ""
        },
        smtStencilParam: {
            dimensionsID: 112,
            stencilQty: 1,
            electropolishing: 0,
            fiducials: 0,
            customizeFlag: 0,
            customizeSizeX: 0,
            customizeSizeY: 0,
            customizeSize: 0,
            stencilSide: 0,
            orderRemark: "",
            framework: 0
        }
    },

    mainPriceInformation : {
        initialFee : 0,
        manufacturingCost: 0,
        metalMask: 0,
        discount: 0,
        subTotal: 0,
        consumptionTax: 0,
        total: 0,
        shippingDate: "N/A",
        deliveryDate: "N/A",
        weight: 0
    },
    priceInformation: { // Default price information
        code: 0,
        message: "This is a sample response!!",
        result: {
            orderTotalWeight: 0,
            pcbCostInfo: {
                achieveFee: 0,
                adornPutFee: 0,
                bigBoardFee: 0,
                charFontColor: 0,
                cuprumThicknessFee: 0,
                fillFee: 0,
                halfHoleFee: 0,
                projectFee: 0,
                rimCutFee: 0,
                spellFee: 0,
                stencilFee: 0,
                testsFee: 0,
                totalFee: 0,
                weight: 0
            },
            smtStencilCostInfo: {
                totalFee: 0,
                weight: 0
            },
            priceWithoutFreight: 0,
            shipList: [
                {
                    options: "N/A",
                    showOptions: "N/A",
                    cost: 0,
                    day: "N/A"
                }
            ]
        }
    }
};

export default InitialQuotationState;



// WEBPACK FOOTER //
// ./src/components/Site/QuotationForm/InitialQuotationState.js